import { render, staticRenderFns } from "./help.vue?vue&type=template&id=220e9b0e&scoped=true"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
import style0 from "./help.vue?vue&type=style&index=0&id=220e9b0e&prod&lang=scss"
import style1 from "./help.vue?vue&type=style&index=1&id=220e9b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e9b0e",
  null
  
)

export default component.exports